import { useEffect, useRef } from 'react';

/**
 * Sincroniza o preenchimento automático do navegador com o estado do formulário.
 *
 * O autofill escreve direto no input e não dispara onChange, então o React
 * continua achando que o campo está vazio: o botão de enviar fica desabilitado
 * e um envio nesse estado mandaria os campos em branco.
 *
 * @param {object} formRef ref do elemento <form> que contém os campos
 * @param {string[]} campos atributos name dos inputs a observar
 * @param {(nome: string, valor: string) => void} aplicar recebe o que o
 *        navegador preencheu; cabe a quem chama comparar com o estado atual e
 *        normalizar o valor antes de gravar
 */
export const useAutofillSync = (formRef, campos, aplicar) => {
    // Mantém a última versão do callback sem reinstalar os listeners a cada render
    const aplicarRef = useRef(aplicar);
    aplicarRef.current = aplicar;

    const camposRef = useRef(campos);
    camposRef.current = campos;

    useEffect(() => {
        const sincronizar = () => {
            const form = formRef.current;
            if (!form) return;

            camposRef.current.forEach(nome => {
                const input = form.querySelector(`input[name="${nome}"]`);
                if (input?.value) aplicarRef.current(nome, input.value);
            });
        };

        // O preenchimento acontece depois da montagem e, em parte dos
        // navegadores, só após a primeira interação com a página
        const tempos = [0, 150, 400, 1000].map(ms => setTimeout(sincronizar, ms));
        window.addEventListener('click', sincronizar);
        window.addEventListener('keydown', sincronizar);

        return () => {
            tempos.forEach(clearTimeout);
            window.removeEventListener('click', sincronizar);
            window.removeEventListener('keydown', sincronizar);
        };
    }, [formRef]);
};

export default useAutofillSync;
